import cfg from '../../config.js'
import {getNetworkProjects, getPseudoNetworkProjects, getType, fetchConnector} from '../api/projects.ts'
import { changeUserName } from '../api/user.js'
import { getInstance } from '../auth/authWrapper'
import { genPartOfId, getError } from '../utils.js'
export default {
    state: {
        isAddUserDialog: false,
        ///
        isLoading: false,
        startLoadingTime: null,
        ///
        isChangeConnectorSettingsDialog: false,
        currentProjectView: 'list',
        connectorsSelected: [],
        currentAddingConnector: null,
        connectorData: JSON.parse(sessionStorage.getItem('connectorData')) || null,
        loggedAddingConnector: null,
        addConectorCredentials: {},
        addConectorSettings: {},
        selectedProjects: [],
        isProjectsLoading: true,
        currentProjectIdToRename: null,
        currentUserIdToRename: null,
        isRenameProjectDialog: false,
        isRenameUserDialog: false,
        currentProjectIdToChangeImage: null,
        isChangeProjectImageDialog: null,
        areAllProjectsLoaded: false,
    },
    mutations: {
        setIsProjectsLoading(state, value) {
            state.isProjectsLoading = value
        },
        setAreAllProjectsLoaded(state, value) {
            state.areAllProjectsLoaded = value;
        },
        setStartLoadingTime(state, value) {
            state.startLoadingTime = value
        },
        setCurrentProjectIdToRename(state, value) {
            state.currentProjectIdToRename = value
        },
        setCurrentProjectIdToChangeImage(state, value) {
            state.currentProjectIdToChangeImage = value
        },
        setIsChangeProjectImageDialog(state, value) {
            state.isChangeProjectImageDialog = value
        },
        setIsRenameProjectDialog(state, value) {
            state.isRenameProjectDialog = value
        },
        setIsRenameUserDialog(state, value) {
            state.isRenameUserDialog = value
        },
        setCurrentUserIdToRename(state, value) {
            state.currentUserIdToRename = value
        },
        setCurrentProjectView(state, projectView) {
            state.currentProjectView = projectView
            localStorage.setItem('currentProjectView', projectView)
        },
        setAddConectorCredentials(state, credentials) {
            state.addConectorCredentials = credentials
            sessionStorage.setItem('currentAddingConnectorCredentials', JSON.stringify(credentials))
        },
        setAddConectorSettings(state, settingsObj) {
            state.addConectorSettings = settingsObj
            sessionStorage.setItem('currentAddingConnectorSettings', JSON.stringify(settingsObj))
        },
        setLoggedAddingConnector(state, connector) {
            state.loggedAddingConnector = connector
            sessionStorage.setItem('loggedAddingConnector', JSON.stringify(connector))
        },
        setConnectorData(state, value) {
            state.connectorData = value
            sessionStorage.setItem('connectorData', JSON.stringify(value))
        },
        updateCurrentAddingConnector(state, value) {
            state.currentAddingConnector = value
            sessionStorage.setItem('currentAddingConnector', JSON.stringify(value))
        },
        updateIsAddUserDialog(state, value) {
            state.isAddUserDialog = value
        },
        updateIsLoading(state, value) {
            state.isLoading = value
        },
        updateSelectedProjects(state, value) {
            state.selectedProjects = value
        },
        updateIsChangeConnectorSettingsDialog(state, value) {
            state.isChangeConnectorSettingsDialog = value
        },
    },
    actions: {
        callRenameProjectDialog({ commit }, projectId) {
            commit('setCurrentProjectIdToRename', projectId)
            commit('setIsRenameProjectDialog', true)
        },
        // silent: true — грузим список без глобального спиннера (isProjectsLoading),
        // чтобы не мигать всей страницей. Используется при ленивой загрузке списка
        // по клику на переключатель проектов в хлебных крошках.
        async setProjects({ commit }, { silent = false } = {}) {
            if (!silent) commit('setIsProjectsLoading', true)
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/getUserProjects`
            const options = {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }

            const projects = await (await fetch(url, options)).json()
            commit('addProjects', projects, { root: true })
            commit('setAreAllProjectsLoaded', true)
            if (!silent) commit('setIsProjectsLoading', false)
        },
        async fetchProject({ commit }, id) { 
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects?projectId=${id}`
            const options = {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
            const project = await (await fetch(url, options)).json()
            commit('setProject', project, { root: true })
        },
        async setFastProjectById({ commit }, id) {
            commit('setIsProjectsLoading', true)
            try {
                const auth = getInstance()
                const token = await auth.getTokenSilently()
                const url = `${cfg.apiEndpoint}/projects/byId?projectId=${id}`
                const options = {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
                const response = await fetch(url, options)
                if (!response.ok) {
                    const error = await getError(response)
                    throw error
                }
                const project = await response.json()
                commit('setProject', project, { root: true })
                commit('setAreAllProjectsLoaded', false)
            } finally {
                commit('setIsProjectsLoading', false)
            }
        },
        async createProject({ commit }, {projectName, isOnBoardingActive, billingEnabledStatus}) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const billingEnabled = billingEnabledStatus
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/createProject`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectName, isOnBoardingActive, billingEnabled }),
            }
            const project = await (await fetch(url, options)).json()
            
            commit('setProject', project, { root: true })
            commit('endLoading', null, { root: true })
            return project
        },
        async deleteProject({ commit }, projectId) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/deleteProject`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId }),
            }
            await fetch(url, options)
            commit('removeProject', projectId, { root: true })
            commit('endLoading', null, { root: true })
        },
        async addConnector({ commit }, payload) {
            // Онбординг подключения канала уже показывает свой спиннер.
            // skipLoading не поднимает общий оверлей App, чтобы индикаторы не накладывались.
            const skipLoading = Boolean(payload?.skipLoading)
            const connector = skipLoading ? payload.connector : payload
            if (!skipLoading) commit("startLoading", null, { root: true });
            const finishLoading = () => {
                if (!skipLoading) commit("endLoading", null, { root: true });
            }
            const auth = getInstance();
            const token = await auth.getTokenSilently();
            const url = `${cfg.apiEndpoint}/projects/addConnector`;
            connector.isDraft = true;
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ connector }),
            }
            const res = await fetch(url, options)
            if (res.status === 200) {
                commit("addConnector", connector, { root: true });
                commit("setLoggedAddingConnector", connector);
                finishLoading();
                return { error: null };
            } else if (res.status === 400) {
                finishLoading();
                const errorData = await res.json();
                return { error: errorData };
            } else {
                finishLoading();
                return { error: "internal server error" };
            }
        },
        async deleteConnector({ commit }, payload) {
            const skipLoading = Boolean(payload?.skipLoading)
            const connectorId = skipLoading || (payload && typeof payload === "object" && "connectorId" in payload)
                ? payload.connectorId
                : payload
            if (!connectorId) return
            if (!skipLoading) commit("startLoading", null, { root: true });
            const finishLoading = () => {
                if (!skipLoading) commit("endLoading", null, { root: true });
            }
            try {
                const auth = getInstance();
                const token = await auth.getTokenSilently();
                const url = `${cfg.apiEndpoint}/projects/deleteConnector`;
                const options = {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ connectorId }),
                };
                const res = await fetch(url, options);
                if (res.status === 200) {
                    commit("removeConnector", connectorId, { root: true });
                }
            } finally {
                finishLoading();
            }
        },
        createConnector({ state }, { projectId, connectorType, providerType, domain, settings }) {
            const id = `${projectId}_${connectorType}_${genPartOfId()}`
            const connector = {
                connectorId: id,
                projectId,
                domain,
                connectorType,
                ...settings,
            }
            // Если передан providerType, добавляем его
            if (providerType) {
                connector.providerType = providerType
            }
            return connector
        },
        async assignPermission({ commit }, payload) {
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/user/assignPermission`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            }
            const res = await await (await fetch(url.toString(), options)).json()
            return res
        },
        async reAssignPermission({ commit }, { projectId, userIdtoChange, roleId }) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/user/reAssignPermission`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId, userIdtoChange, roleId }),
            }
            const res = await fetch(url, options)
            if (res.status === 200) {
                commit('changeUserRole', { projectId, userId: userIdtoChange, roleId }, { root: true })
            } else {
                const error = await getError(res)
                commit('setError', error, { root: true })
            }
            commit('endLoading', null, { root: true })
        },
        async unAssignPermission({ commit }, { projectId, userId }) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/user/unAssignPermission`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId, userId }),
            }
            const res = await fetch(url, options)
            commit('endLoading', null, { root: true })
        },
        async updateConnectorSettings({ commit }, { connectorId, settings }) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/updateConnectorSettings`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ connectorId, settings }),
            }
            const connector = await (await fetch(url, options)).json()

            commit('updateConnector', connector, { root: true })
            commit('endLoading', null, { root: true })
            // Используем коннектор из ответа, если он есть, иначе делаем запрос на получение актуальных данных
            if (connector && connector.connectorId) {
                commit('updateConnector', connector, { root: true })
            } else {
                // Если ответ не содержит коннектор, делаем запрос на получение актуальных данных
                const { data: updatedConnector, error } = await fetchConnector(connectorId)
                if (!error && updatedConnector) {
                    commit('updateConnector', updatedConnector, { root: true })
                } else {
                    console.error('Ошибка при получении данных коннектора:', error)
                }
            }
            commit('endLoading', null, { root: true })
        },
        async updateProjectSettings({ commit }, { projectId, settings }) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/updateProjectSettings`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId, settings }),
            }
            const project = await (await fetch(url, options)).json()
            commit('updateProject', project, { root: true })
            commit('endLoading', null, { root: true })
        },
        async renameProject({ commit }, { projectId, name }) {
            commit('startLoading', null, { root: true })
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/rename`
            const options = {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId, name }),
            }
            const project = await (await fetch(url, options)).json()
            commit('updateProject', project, { root: true })
            commit('endLoading', null, { root: true })
        },
        async update({ commit, dispatch }, { projectId, excludedStages }) {
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/data/updateDataLayers`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId, excludedStages: excludedStages }),
            }
            const res = await fetch(url, options)
            if (res.status === 200) {
                //await dispatch('setProjects')
            } else {
                const error = await getError(res)
                if (error.code !== 409) {
                    commit('setError', error, { root: true })
                }
            }
        },
        async updateServiceProvided({ commit }, projectId) {
            console.log('UPDATE')
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/data/updateServiceProvided`
            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ projectId }),
            }
            const res = fetch(url, options)
        },
        async getLoading({ commit }, projectId) {
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/getLoading?projectId=${projectId}`
            const options = {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }

            const loading = await (await fetch(url, options)).json()
            return loading
        },
        async getChisaiIsInit({ commit }, { projectId, connectorType }) {
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/getChisaiIsInit?projectId=${projectId}&connectorType=${connectorType}`
            const options = {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
            try {
                const isInit = await (await fetch(url, options)).json()
                return isInit
            } catch (err) {
                const error = await getError(res)
                commit('setError', error, { root: true })
            }
        },
        async changeProjectImage({ commit }, { projectId, file }) {
            const auth = getInstance()
            const token = await auth.getTokenSilently()
            const url = `${cfg.apiEndpoint}/projects/changeProjectImage`
            let formData = new FormData()
            formData.append('projectId', projectId)
            formData.append('file', file, file.name)
            const options = {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            }
            const updatedProject = await (await fetch(url, options)).json()
            commit('updateProject', updatedProject, { root: true })
        },
        async changeUserName({ commit }, { projectId, userId, name }) {
            commit('changeUserName', { projectId, userId, name }, { root: true })
            const res = await changeUserName(projectId, userId, name)
        },
        addUser({commit}, {user, projectId}) {
            commit('addUser', {user, projectId}, { root: true })
        },
        async setNetworkProjects({ commit }, { projectId }) {
            const res = await getNetworkProjects({ projectId })
            if (!res.error) {
                commit('setNetworkProjects', res.data, { root: true })
            }
        },
        async setPseudoNetworkProjects({ commit }, { projectId }) {
            const res = await getPseudoNetworkProjects({ projectId })
            if (!res.error) {
                commit('setPseudoNetworkProjects', res.data, { root: true })
            }
        },
        async setProjectType({ commit }, { projectId }) {
            const res = await getType({ projectId })
            if (!res.error) {
                commit('setProjectType', res.data?.type, { root: true })
            }
        },
    },
    getters: {},
}
